// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `v-search .searchbar {
  position: relative;
}
v-search .searchbar .search-icon {
  position: absolute;
  top: 12px;
  left: 14px;
  z-index: 1;
}
v-search .searchbar .load-icon, v-search .searchbar .clear-icon {
  position: absolute;
  top: 12px;
  right: 14px;
}
v-search .searchbar .load-icon {
  right: 12px !important;
}
v-search .searchbar input {
  padding: 0.5rem 0.5rem 0.5rem 2.5rem !important;
}`, "",{"version":3,"sources":["webpack://./src/app/components/v-search/v-search.component.sass"],"names":[],"mappings":"AACI;EACI,kBAAA;AAAR;AACQ;EACI,kBAAA;EACA,SAAA;EACA,UAAA;EACA,UAAA;AACZ;AAAQ;EACI,kBAAA;EACA,SAAA;EACA,WAAA;AAEZ;AADQ;EACI,sBAAA;AAGZ;AAFQ;EACI,+CAAA;AAIZ","sourcesContent":["v-search\n    .searchbar\n        position: relative\n        .search-icon\n            position: absolute\n            top: 12px\n            left: 14px\n            z-index: 1\n        .load-icon, .clear-icon\n            position: absolute\n            top: 12px\n            right: 14px\n        .load-icon\n            right: 12px !important\n        input\n            padding: 0.5rem 0.5rem 0.5rem 2.5rem !important"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
